// C:\dev\Crowd_Insight-\src\pages\Login_Sign\assets\styles\Images.jsx

import Filter from "../images/Filter.svg";
import BgSearch from "../images/BgSearch.png";
import Search from "../images/Search.svg";

import BtnFirst from "../images/btnFirst.svg";
import BtnPrev from "../images/btnPrev.svg";
import BtnNext from "../images/btnNext.svg";
import BtnEnd from "../images/btnEnd.svg";
import GoogleIcon from '../images/GoogleIcon.svg';

const images = {
  Filter,
  BgSearch,
  Search,
  BtnFirst,
  BtnPrev,
  BtnNext,
  BtnEnd,
  GoogleIcon
}

export default images;
